module.exports = __webpack_public_path__ + "img/INTERIOR-CIAZ-3.34ea14ec.jpg";